module.exports = __webpack_public_path__ + "overview-d35a4493/upsell_icon_green-817a491095e73d4474b1b299862ffb41.png";